<div class="sticky-element" [class.fixed]="fixed" #element
  [style.top]="atBottom ? 'auto' : (paddingY + (fixed ? offsetY : 0)) + 'px'" [style.right]="paddingX + 'px'"
  [style.zIndex]="zIndex" [style.bottom]="atBottom ? paddingY + 'px' : 'auto'"
  [style.height]="autoFill ? (height + 'px') : 'auto'" [class.full-width]="fullWidth">
  <ng-content></ng-content>
</div>
